import { memo, useState, useEffect } from 'react';
import { useStore } from 'store/StoreContext';
import { RegisterUserData, storeOnetimePasswordGenerator } from 'store/register-user/RegisterUserData';
import { saveGenerator as saveGeneratorV2 } from 'store/connect/AuthorizeV2Data';
import { useReceiveV2AuthorizeRequest } from 'hooks/UseReceiveV2AuthorizeRequest';
import { RequiredProfileEditTemplate } from 'components/templates/RequiredProfileEditTemplate';

type Props = {};

export const RequiredProfileEditPage = memo((_props: Props) => {
	const [store, dispatch] = useStore();
	const [loading, setLoading] = useState(true);
	const registerUserData: RegisterUserData = store.registerUserData;
	const { v2Params, isV2ParamsOk } = useReceiveV2AuthorizeRequest();
	useEffect(() => {
		const execute = async () => {
			registerUserData.isV2ParamsOk = true;
			await storeOnetimePasswordGenerator(dispatch, registerUserData);
			await saveGeneratorV2(dispatch, v2Params);
			setLoading(false);
		};
		execute();
	}, []);
	if (loading) {
		return null;
	}
	return (
		<>
			{!!v2Params?.response_type && !!v2Params?.client_id ? (
				<RequiredProfileEditTemplate />
			) : (
				<section className="section">
					<div className="section-in">
						<div className="error-box">
							<div className="error-box-in">
								<p>必要なパラメータが存在しません。</p>
							</div>
						</div>
					</div>
				</section>
			)}
		</>
	);
	// return <RequiredProfileEditTemplate />;
});
